import template from './price-filter.view.html';
function PriceFilterDirective () {
  return {
    restrict: 'E',
    template
  };
}

PriceFilterDirective.$inject = [];

export default PriceFilterDirective;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/catalog/products-list/price-filter/price-filter.directive.js
 **/